<template>
  <page-content-placeholder
    :img-src="RoomCategoriesImage"
    max-width="640px"
    class="mt-10 mb-0 pl-0 pr-0"
    text="У объекта размещения отсутствуют категории номеров"
  >
    <div class="paragraph-m_h mt-2">
      Для продолжения, необходимо создать Категории номеров в разделе
      <router-link :to="{ name: RouteNames.RoomCategories }" class="link">Категории номеров</router-link>. Отправка
      анкеты доступна после заполнения всех разделов.
    </div>

    <e-btn variant="link" class="mt-4" append-icon-src="arrowRight" :to="{ name: RouteNames.RoomCategories }">
      Перейти в раздел Категории номеров
    </e-btn>
  </page-content-placeholder>

  <div class="d-flex justify-space-between mt-auto mt-md-10">
    <e-btn variant="secondary" prepend-icon-src="arrowLeft" @click="back">Назад</e-btn>
    <e-btn variant="primary" append-icon-src="arrowRight" disabled>Далее</e-btn>
  </div>
</template>

<script setup lang="ts">
import RoomCategoriesImage from '@/assets/img/pages/room-categories/no-room-categories.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import { EBtn } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { useContentStore } from '@/parts/content/store';

const { back } = useContentStore();
</script>
